import { isAccountCodeWithinGlobalBounds } from "@common/constants/domains/accounting/accountCodeBounds";
import { parsePlainIntegerCodeText } from "@common/helpers/accounting";

export interface TemplateAccountCodes {
    codeText: string | null;
    code: number | null;
}

export const resolveTemplateAccountCodes = (
    codeText: string | null,
): TemplateAccountCodes => {
    const trimmedCodeText = codeText?.trim() ?? "";
    if (trimmedCodeText.length === 0) {
        return { codeText: null, code: null };
    }
    const parsedCode = parsePlainIntegerCodeText(trimmedCodeText);
    return {
        codeText: trimmedCodeText,
        code:
            parsedCode !== null && isAccountCodeWithinGlobalBounds(parsedCode)
                ? parsedCode
                : null,
    };
};

export const createTemplateCodeClaimer = (): ((
    codeText: string | null,
) => boolean) => {
    const takenCodeTexts = new Set<string>();
    const takenCodes = new Set<number>();
    return (codeText) => {
        const resolved = resolveTemplateAccountCodes(codeText);
        if (resolved.codeText === null) {
            return true;
        }
        if (
            takenCodeTexts.has(resolved.codeText) ||
            (resolved.code !== null && takenCodes.has(resolved.code))
        ) {
            return false;
        }
        takenCodeTexts.add(resolved.codeText);
        if (resolved.code !== null) {
            takenCodes.add(resolved.code);
        }
        return true;
    };
};
